var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating",class:{ 'rating-decimal': _vm.isDecimal },on:{"click":function($event){return _vm.$emit('click')}}},_vm._l((_vm.formatedRates),function(rate){return _c('Icon',{key:rate,staticClass:"star",attrs:{"icon":"star"}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9ed9692","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rating.vue
// module id = 836
// module chunks = 1